import { debounce } from '@shared/utils/throttleDebounce'
import { ref, watch } from 'vue'

export const useDebounce = (sourceRef, callback, delay = 300, condition = () => true) => {
  const internalValue = ref(sourceRef.value)

  const debouncedCallback = debounce((value) => {
    if (condition(value)) {
      callback(value)
    }
  }, delay)

  watch(sourceRef, (newValue) => {
    internalValue.value = newValue
    debouncedCallback(newValue)
  })
}
